import { Routes, Route } from 'react-router-dom';
import { useAuth } from '@/context/auth';
import { CareerProvider } from '@/context/CareerContext';
import { CareerPathProvider } from '@/context/CareerPathContext';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';
import { routes } from '@/routes/config';
import { CookieConsent } from './components/CookieConsent';

function App() {
  const { user, loading, initialized, error } = useAuth();
  
  console.log('App rendering:', { 
    hasUser: !!user, 
    loading, 
    initialized,
    hasError: !!error 
  });

  if (!initialized) {
    console.log('App showing loading state');
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" message="Loading application..." />
      </div>
    );
  }

  if (error) {
    console.error('App error:', error);
  }

  return (
    <div className="min-h-screen">
      <CareerProvider>
        <CareerPathProvider>
          <Routes>
            {routes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={route.element}
              />
            ))}
          </Routes>
          <CookieConsent />
        </CareerPathProvider>
      </CareerProvider>
    </div>
  );
}

export default App;